// Global Spotlight Command Palette (04 §Global chrome)
// Quick dual-script search across leads and routes with '/' or 'Ctrl+K'.

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLeads } from '../features/leads/useLeads.js';
import { ROUTES } from '../app/routes.js';
import { IconClose, IconSearch } from './Icons.js';

export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const { data: leads = [] } = useLeads('');

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!open) return null;

  const q = query.trim().toLowerCase();

  const filteredRoutes = ROUTES.filter(
    (r) => r.labelBg.toLowerCase().includes(q) || r.labelEn.toLowerCase().includes(q),
  );

  const filteredLeads = leads
    .filter(
      (lead) =>
        lead.business_name.toLowerCase().includes(q) ||
        (lead.area && lead.area.toLowerCase().includes(q)) ||
        (lead.phone && lead.phone.includes(q)) ||
        (lead.domain_norm && lead.domain_norm.toLowerCase().includes(q)),
    )
    .slice(0, 8);

  const handleSelectRoute = (path: string) => {
    navigate(path);
    onClose();
    setQuery('');
  };

  const handleSelectLead = (id: number) => {
    navigate(`/leads/${id}`);
    onClose();
    setQuery('');
  };

  return (
    <div className="cmd-overlay" onClick={onClose}>
      <div className="cmd-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="cmd-inputwrap">
          <IconSearch size={18} className="cmd-searchicon" />
          <input
            autoFocus
            type="search"
            placeholder="Търсене на обект, телефон, район или екран…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="cmd-input"
          />
          <button type="button" className="cmd-close" onClick={onClose}>
            <IconClose size={16} />
          </button>
        </div>

        <div className="cmd-body">
          {q !== '' && filteredLeads.length > 0 && (
            <div className="cmd-section">
              <div className="cmd-sectiontitle">Обекти ({filteredLeads.length})</div>
              {filteredLeads.map((lead) => (
                <button
                  key={lead.id}
                  type="button"
                  className="cmd-item"
                  onClick={() => handleSelectLead(lead.id)}
                >
                  <div className="cmd-itemmain">
                    <span className="cmd-itemtitle">{lead.business_name}</span>
                    <span className="cmd-itemmeta">
                      {lead.area ?? lead.city_key}
                      {lead.phone ? ` · ${lead.phone}` : ''}
                      {lead.domain_norm ? ` · ${lead.domain_norm}` : ''}
                    </span>
                  </div>
                  {lead.lead_score !== null && (
                    <span className="badge badge--score">{lead.lead_score} т.</span>
                  )}
                </button>
              ))}
            </div>
          )}

          <div className="cmd-section">
            <div className="cmd-sectiontitle">Бърза навигация</div>
            <div className="cmd-grid">
              {filteredRoutes.map((route) => (
                <button
                  key={route.path}
                  type="button"
                  className="cmd-routebtn"
                  onClick={() => handleSelectRoute(route.path)}
                >
                  <span className="cmd-routename">{route.labelBg}</span>
                  <span className="cmd-routepath">{route.path}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
